// extracted by mini-css-extract-plugin
var _1 = "z7VfBCiWCbuHk_E1YDYw";
export { _1 as "divider" }
